const getPaymentTermsValue = (deposit_percentage: number) => {
  if (deposit_percentage === 1) {
    return '100% deposit';
  } else if (deposit_percentage > 0) {
    return `${deposit_percentage * 100}% deposit, ${100 - deposit_percentage * 100}% before shipping`;
  }

  return '-';
};

export default getPaymentTermsValue;
